import { TraceApiEndpointBuilder } from '../traceApi';

export interface IDeviceInfo {
  name?: string;
  platform?: string;
  browser?: string;
  userAgent?: string;
}

export interface ISession {
  _id: string;
  userId: string;
  deviceInfo?: IDeviceInfo;
  createdAt: string;
  lastActivity: string;
  expiresAt: string;
  isTvSession?: boolean;
}

export const createSessionsEndpoint = (builder: TraceApiEndpointBuilder) => ({
  // Register a new session
  registerSession: builder.mutation<ISession, { deviceInfo?: IDeviceInfo }>({
    query: (body) => ({
      url: '/sessions/register',
      method: 'POST',
      body,
      skipAuthGuard: true,
    }),
  }),

  // Get all user sessions
  getAllSessions: builder.query<ISession[], void>({
    query: () => ({
      url: '/sessions',
      method: 'GET',
    }),
  }),

  // Update session activity (heartbeat)
  heartbeatSession: builder.mutation<void, void>({
    query: () => ({
      url: '/sessions/heartbeat',
      method: 'POST',
      skipAuthGuard: true,
    }),
  }),

  // Revoke a specific session
  revokeSession: builder.mutation<void, string>({
    query: (sessionId) => ({
      url: `/sessions/${sessionId}`,
      method: 'DELETE',
    }),
  }),

  // Revoke all sessions except current
  revokeAllSessions: builder.mutation<void, { exceptSessionId?: string }>({
    query: (body) => ({
      url: '/sessions/all',
      method: 'DELETE',
      body,
    }),
  }),
}); 